/** English copy. Ключи и порядок держим синхронными с `ru.ts`. */
const en: Record<string, string> = {
  "Report a problem": "Report a problem",
  "Report code": "Report code",
  "Sending…": "Sending…",
  "Send report to developers": "Send report to developers",
  "Describe what happened (optional)": "Describe what happened (optional)",
  "Thanks, developers will look into it": "Thanks! The developers are already looking into it.",
  "Could not send, save the code": "Couldn't send. Save the code and give it to support.",
  "Send the details to developers so they can fix it faster": "Send the details to the developers so they can fix it faster.",
  "Close": "Close",
  "Choose Plan": "Choose Plan",
  "Active Subscription": "Active Subscription",
  "No logs": "Strict No-Logs Policy",
  "Works globally": "Works Everywhere",
  "Easy payment": "Pay in Crypto or Cards",
  "Plans": "Plans",
  "Home": "Home",
  "Activity": "Activity",
  "Settings": "Settings",
  "Profile": "Profile",
  "Disabled title": "This bot is unavailable",
  "Disabled description": "The owner may have paused sales, or your account is blocked. If you think this is a mistake, contact support.",
  "Disabled close": "Close",
  "Webapp off title": "The app is turned off",
  "Webapp off description": "The bot owner sells through chat. Go back to the conversation to pick a plan, pay and get access.",
  "Webapp off close": "Back to chat",
  "Tg offline title": "Telegram is not responding",
  "Tg offline description": "We could not get your sign-in data. Usually it is a lost connection or an active VPN. Check the internet and open the app again.",
  "Tg offline retry": "Reload",
  "Tg no init data title": "Open from the bot",
  "Tg no init data description": "Sign-in data comes from Telegram. A direct browser link will not work: open the app from the bot menu button.",
  "Days left": "Days left",
  "Renew": "Renew",
  "Change plan": "Change plan",
  "Devices": "Devices",
  "Auto-renew": "Auto-renew",
  "Auto-renew desc": "Renew 24 hours before expiry. Charged from your balance.",
  "Gift Subscription": "Gift Subscription",
  "Copy referral link": "Copy link",
  "Invite a Friend": "Invite a Friend",
  "Copy Link": "Copy Link",
  "Freeze Subscription": "Freeze Subscription",
  "Current Plan": "Current Plan",
  "Active": "ACTIVE",
  "Traffic Used": "Traffic Used",
  "Manage": "Manage",
  "Connected": "Connected",
  "Language saved on this device only": "Saved on this device only. The bot may keep the old language.",
  "Giveaways": "Giveaways",
  "No giveaways yet": "No giveaways right now",
  "When a giveaway starts, it will appear here.": "When a giveaway starts, it will show up here.",
  "Prize": "Prize",
  "Take part": "Take part",
  "Check again": "Check again",
  "Drawing winners…": "Drawing winners…",
  "Drawing in progress — results will arrive in the bot.": "The draw is running: the result will arrive in the bot.",
  "You're in. We'll message you in the bot when it ends.": "You're in. We'll message you in the bot when it ends.",
  "You won! The prize is already on your account.": "You won! The prize is already on your account.",
  "Subscribe to": "Subscribe to",
  "the channel": "the channel",
  "Invite friends who buy a plan": "Invite friends who buy a plan",
  "of": "of",
  "Could not check — try again in a minute.": "Couldn't check, try again in a minute.",
  "Referral copy": "Get +5 GB and 15% from their payments",
  "Order Summary": "Order Summary",
  "Payment Method": "Payment Method",
  "Promo Code": "Promo Code",
  "Apply": "Apply",
  "Promo placeholder": "DISCOUNT10",
  "Promo applied": "Promo {{code}} applied: {{discount}} off",
  "Promo too short": "Code too short",
  "Promo too long": "Code too long",
  "Promo invalid": "Invalid promo code",
  "Promo discount toast": "Promo applied! {{discount}} off.",
  "Terms agreement": "By paying, you agree to the Terms of Service.",
  "Terms agreement prefix": "By paying, you accept the",
  "Terms agreement link": "terms of service",
  "Processing Payment": "Processing Payment",
  "Processing hint": "This usually takes 5-15 seconds.",
  "Verifying payment": "Verifying payment",
  "Creating subscription": "Creating subscription",
  "Preparing config": "Preparing config",
  "Go to dashboard": "Go to dashboard",
  "Subscription Ready": "Subscription Ready",
  "Subscription Ready desc": "Your VPN is ready to use.",
  "Connect on": "Connect on {{os}}",
  "Connect on this device": "Connect on this device",
  "Connect another device": "Connect another device",
  "Connect other devices desc": "Copy this subscription URL and paste it into your VPN client: INCY, Happ, V2RayTun or Streisand. On some iPhones Happ shows the whitelist-bypass servers (at the end of the list) incorrectly, so for iPhone we recommend INCY.",
  "Copy": "Copy",
  "Copied": "Copied",
  "Language": "Language",
  "Privacy Policy": "Privacy Policy",
  "Support": "Support",
  "Network status": "Network status",
  "Status operational": "Everything is working",
  "Status degraded": "Partial outage",
  "Status down": "Major outage",
  "Status no data": "Collecting data",
  "Status vpn network": "VPN network",
  "Status section network": "{{section}} network",
  "Status locations": "Locations",
  "Status uptime": "Uptime",
  "Status countries": "Countries",
  "Status days ago": "{{count}} days ago",
  "Status today": "today",
  "Status checked": "Checked {{time}}",
  "Status empty": "The country list will appear after the next sync.",
  "Status unavailable": "Status is unavailable right now. Please try again later.",
  "Status label ok": "Operational",
  "Status label none": "No data",
  "Status time now": "just now",
  "Status time min": "{{count}} min ago",
  "Status time hour": "{{count}} h ago",
  "Status time day": "{{count}} d ago",
  "No devices": "No devices",
  "No devices desc": "You haven't connected any devices yet.",
  "No activity": "No activity",
  "No activity desc": "No connection logs match this filter.",
  "Reviews": "Reviews",
  "Reviews latest": "Latest reviews",
  "Reviews recommends": "Recommends",
  "Shop reply": "Reply from the shop",
  "Reviews complains": "Has complaints",
  "Reviews verified note": "Verified subscriptions only",
  "Reviews empty": "No reviews yet",
  "Reviews empty desc": "Leave the first one, it will show up here right away.",
  "Reviews leave": "Leave a review",
  "Reviews edit": "Edit review",
  "Review reward given": "A {{percent}}% discount on your next purchase is waiting for you.",
  "Review hidden": "Review hidden",
  "Review hidden desc": "Your review is not shown on the storefront and cannot be edited.",
  "Review sub hidden": "review hidden",
  "Reviews form title": "How is the service?",
  "Reviews form hint": "The rating is required, the text is optional.",
  "Reviews thanks": "Thank you, your review is published",
  "Disclose free": "Mention that the subscription was received for free",
  "Disclose promo": "Mention that the subscription was activated with a promo code",
  "Review badge free": "Received for free",
  "Review badge promo": "With a promo code",
  "Filter all": "All",
  "Filter success": "Success",
  "Filter failed": "Failed",
  "Upgrade Plan": "Upgrade Plan",
  "Order plan": "{{devices}} devices",
  "Auto-renew on": "Auto-renew enabled",
  "Auto-renew off": "Auto-renew disabled",
  "Pay via": "PAY {{price}}\u00a0₽ VIA {{provider}}",
  "Checkout total via": "To pay {{price}}\u00a0₽ via {{provider}}",
  "Checkout total balance": "{{price}}\u00a0₽ from your balance",
  "Upgrade to": "UPGRADE TO {{plan}}",
  "Tg user fallback": "Telegram user",
  "Profile section account": "Account",
  "Profile section program": "Program",
  "Profile section help": "Help & settings",
  "Profile balance": "Wallet balance",
  "Profile referrals": "Referral program",
  "Profile referrals invited": "invited",
  "Profile gift": "Gift subscription",
  "Profile devices": "My devices",
  "Profile subscription": "My subscription",
  "Profile freeze": "Freeze subscription",
  "Profile logout": "Reset local cache",
  "Profile version": "App version",
  "Referral link copied": "Referral link copied",
  "Giveaway invite link copied": "Link copied",
  "Plans filter days": "Days",
  "Plans filter devices": "Devices",
  "Plans filter traffic": "Traffic",
  "Plans filter all": "All",
  "Plans empty": "No plans match the current filters",
  "Local cache cleared": "Local cache cleared",
  "Clipboard unavailable": "Couldn't copy. Long-press the link instead.",
  "Crash title": "Something broke",
  "Unknown error": "Unknown error",
  "Reload page": "Reload",
  "Cancel": "Cancel",
  "Badge active": "Active",
  "Badge frozen": "Frozen",
  "Badge expired": "Expired",
  "Pay with": "Pay with",
  "Provider platega": "SBP",
  "Provider aurapay": "SBP 2",
  "Provider aurapay_card": "Bank card",
  "Provider antilopay": "SBP",
  "Provider stars": "Stars",
  "Count ratings_one": "{{count}} rating",
  "Count ratings_few": "{{count}} ratings",
  "Count ratings_many": "{{count}} ratings",
  "Count ratings_other": "{{count}} ratings",
  "Reviews positive": "Positive",
  "Reviews complaints": "Complaints",
  "Verified subscription": "Verified subscription",
  "Months with us_one": "{{count}} month with us",
  "Months with us_few": "{{count}} months with us",
  "Months with us_many": "{{count}} months with us",
  "Months with us_other": "{{count}} months with us",
  "Review renewed": "renewed",
  "Review until": "until {{date}}",
  "Review send failed": "Couldn't send the review",
  "Review subject": "Which subscription is this about",
  "Review sub ended": "ended",
  "Review sub reviewed": "reviewed",
  "Rating aria": "Rating {{n}}",
  "Rating of five aria": "Rating {{n}} out of 5",
  "Review placeholder": "What you liked, or what needs fixing",
  "Count days_one": "{{count}} day",
  "Count days_few": "{{count}} days",
  "Count days_many": "{{count}} days",
  "Count days_other": "{{count}} days",
  "Count weeks_one": "{{count}} week",
  "Count weeks_few": "{{count}} weeks",
  "Count weeks_many": "{{count}} weeks",
  "Count weeks_other": "{{count}} weeks",
  "Count months_one": "{{count}} month",
  "Count months_few": "{{count}} months",
  "Count months_many": "{{count}} months",
  "Count months_other": "{{count}} months",
  "Count years_one": "{{count}} year",
  "Count years_few": "{{count}} years",
  "Count years_many": "{{count}} years",
  "Count years_other": "{{count}} years",
  "Count devices_one": "{{count}} device",
  "Count devices_few": "{{count}} devices",
  "Count devices_many": "{{count}} devices",
  "Count devices_other": "{{count}} devices",
  "Count locations_one": "{{count}} location",
  "Count locations_few": "{{count}} locations",
  "Count locations_many": "{{count}} locations",
  "Count locations_other": "{{count}} locations",
  "This device": "this device",
  "Confirm action": "Confirm the action",
  "Confirm": "Confirm",
  "Open from bot menu": "Open the app from the bot's menu button.",
  "Connections": "Connections",
  "Connections desc": "A log of your devices connecting to the VPN. If you see an IP that isn't yours, the config has leaked: remove that device.",
  "Device hwid": "Device {{id}}",
  "Device unknown": "Unknown device",
  "Support not set up": "Support is not set up for this bot",
  "FAQ what is it": "What this is",
  "FAQ about fallback": "A VPN service for fast, private access to the internet.",
  "FAQ whats inside": "What you get",
  "FAQ payment note": "Payment: crypto (CryptoBot / Heleket) and Russian bank cards. Questions? Message support from your profile.",
  "Documents": "Documents",
  "Terms of service": "Terms of service",
  "Privacy policy": "Privacy policy",
  "Servers": "Servers",
  "Locations auto pick": "The nearest one is picked automatically. Any VPN client connects on its own.",
  "Locations unavailable": "The list is unavailable right now. Please try again later.",
  "Connect to any": "Connect to any of them",
  "Connect to any desc": "Pick a plan and the VPN turns on instantly",
  "Updated at": "Updated: {{time}}",
  "Reviews filter good": "Good",
  "Reviews filter bad": "Bad",
  "Reviews positive share": "{{percent}}% positive",
  "Shown of total": "{{shown}} of {{total}}",
  "Loading": "Loading",
  "Show more": "Show more",
  "Region Europe": "Europe",
  "Region North America": "North America",
  "Region South America": "South America",
  "Region Asia": "Asia",
  "Region Oceania": "Oceania",
  "Region Africa": "Africa",
  "Region Other": "Other",
  "Locations word_one": "location",
  "Locations word_few": "locations",
  "Locations word_many": "locations",
  "Locations word_other": "locations",
  "Intent subscribe": "Subscription purchase",
  "Intent renew": "Renewal",
  "Intent upgrade": "Upgrade",
  "Intent traffic": "Traffic purchase",
  "Intent addon": "Subscription add-on",
  "Intent devices": "Extra devices",
  "Intent topup": "Wallet top-up",
  "Intent unknown": "Top-up",
  "Intent referral bonus": "Referral bonus",
  "Intent adjustment": "Balance adjustment",
  "Intent refund": "Refund",
  "Intent voucher": "Voucher",
  "Intent giveaway prize": "Giveaway prize",
  "Intent gift": "Gift for a friend",
  "Intent payment": "Payment",
  "Intent credit": "Added to balance",
  "Intent debit": "Charged from balance",
  "Payment status paid": "Paid",
  "Payment status pending": "Awaiting payment",
  "Payment status failed": "Failed",
  "Payment status cancelled": "Cancelled",
  "Payment status expired": "Invoice expired",
  "Payment status refunded": "Refunded",
  "Source balance": "From balance",
  "Payments history": "Payment history",
  "Payments load failed": "Couldn't load the history.",
  "Retry": "Try again",
  "Payments empty": "No payments yet.",
  "Topup title": "Top up your wallet",
  "Topup desc": "The money lands on your wallet balance. Spend it later on renewals, upgrades or extra traffic.",
  "Amount": "Amount",
  "Custom amount": "Custom amount (₽)",
  "Custom amount hint": "for example 750",
  "Topup fee note": "You pay {{total}} ₽: {{percent}}% goes to the payment system. Your balance gets {{amount}} ₽, and purchases from it carry no extra charge.",
  "Invoice failed": "Couldn't create the invoice",
  "No providers": "No payment providers are set up.",
  "No providers support": "No payment providers are set up. Please contact support.",
  "Upgrade done": "Plan updated",
  "Upgrade no balance": "Not enough on your balance. Top it up and try again.",
  "Upgrade plan gone": "That plan is unavailable, pick another one.",
  "Upgrade failed": "Couldn't switch to that plan",
  "Upgrade confirm exact": "Switch to {{plan}}? {{amount}} will be charged from your balance.",
  "Upgrade confirm": "Switch to {{plan}}? The difference will be charged from your balance.",
  "Upgrade confirm title": "Confirm the switch",
  "Upgrade current plan": "Current plan",
  "Upgrade rule": "The surcharge is the new plan price minus the unused part of your current one. It is taken from your balance, and the new plan\u2019s term starts over. You can only move to a bigger plan within the same period.",
  "Upgrade surcharge": "surcharge",
  "Upgrade none title": "There is no bigger plan on the «{{period}}» period.",
  "Upgrade none desc": "To get more devices or traffic, wait until this subscription ends and buy a new one.",
  "Plan devices unlim": "{{devices}} · unlimited",
  "Plan devices unlim gb": "{{devices}} · unlimited · {{gb}} GB for restricted sites",
  "Giveaway soon": "results soon",
  "Giveaway left min": "{{count}} min left",
  "Giveaway left hour": "{{count}} h left",
  "Giveaway left day": "{{count}} d left",
  "Giveaway no tasks": "Anyone can enter, no tasks required.",
  "Giveaway invite link": "Your invite link",
  "Giveaway open channel": "Open the channel",
  "Share": "Share",
  "Giveaway share text": "Get my VPN and my invite counts",
  "Giveaway tile new": "New giveaway, take part",
  "Giveaway tile ready": "You can take part",
  "Own VPN": "Your own VPN",
  "Open in browser": "Open in browser",
  "Open in browser hint": "Works even without Telegram",
  "Site link failed": "Could not open the website. Please try again.",
  "Site link too often": "Too many attempts. Wait a minute and try again.",
  "Own VPN hint": "Your own shop with your prices: earn on VPN",
  "Giveaway tile joined": "You're in, waiting for the draw",
  "Giveaway tile todo": "Complete the tasks to take part",
  "Trial freeze note": "A trial can't be frozen. Freezing works on paid plans.",
  "Referral link missing": "The referral link isn't ready yet",
  "Link copied": "Link copied",
  "Referral share text": "Get my VPN: fast and no logs",
  "Upgrade action": "Upgrade",
  "Save failed": "Couldn't save",
  "Sub unfrozen": "Subscription unfrozen",
  "Sub frozen": "Subscription frozen",
  "Refreshing status": "That didn't work, refreshing the status",
  "Frozen": "Frozen",
  "Until date": "until {{date}}",
  "Trial period": "Trial",
  "Traffic bypass left": "Left for restricted sites",
  "Traffic of total": "GB of {{total}}",
  "Traffic note trial": "Traffic is unlimited on regular locations. The trial has no servers for restricted sites: those come with paid plans.",
  "Traffic note paid": "The limit applies only to servers for restricted sites. Regular locations are unlimited. Used over the life of this subscription: {{used}} GB. Renewing raises the limit; usage is not reset.",
  "Connect VPN": "Connect the VPN",
  "Trial cannot renew": "A trial can't be renewed: pick a plan instead",
  "Freeze": "Freeze",
  "Unfreeze": "Unfreeze",
  "Buy GB": "Buy GB",
  "Gift": "Gift",
  "Top up": "Top up",
  "Invite a friend": "Invite a friend",
  "Referral explain l1": "Share your link, your friend buys a plan, and you get",
  "Referral explain l1 tail": "of their payments on your balance.",
  "Referral explain l2": "And if they invite someone too, you also get",
  "Referral explain l2 tail": "from the second level.",
  "Already invited": "Invited so far:",
  "Freeze title": "Freeze the subscription?",
  "Unfreeze title": "Unfreeze the subscription?",
  "Unfreeze desc": "The subscription becomes active again and days start counting down.",
  "Freeze desc": "Days stop counting down. You can unfreeze at any time.",
  "Rotate failed": "Couldn't refresh the link, try again later",
  "Rotating": "Refreshing…",
  "Rotate confirm": "Sure? Tap once more",
  "Rotate link": "Refresh the link",
  "Rotate wait": "Available in {{count}} min",
  "Rotate warn short": "The old address stops working",
  "New sub address": "New subscription address:",
  "Rotate note": "You'll have to add the profile to your app again. Anyone already connected with the old link stays until this subscription ends.",
  "Home hero title": "Get the VPN running in a minute",
  "Home hero desc": "Pick a plan and the config opens right after payment. No sign-up, no apps.",
  "Open plans": "See the plans",
  "Feature fast": "Fast",
  "Feature fast hint": "VLESS Reality, minimal latency",
  "Feature private": "Private",
  "Feature private hint": "No traffic logs",
  "Feature simple": "Simple",
  "Feature simple hint": "Scan a QR and you're done",
  "Have promo": "Got a promo code?",
  "Have promo desc": "Enter it on the next step when picking a plan and the discount applies automatically.",
  "Traffic invoice open": "The invoice is open. The GB land automatically once it's paid.",
  "Invoice failed detail": "Couldn't create the invoice: {{error}}",
  "Buy traffic": "Buy traffic",
  "Buy traffic desc": "Extra GB on top of your current subscription. Pay at the provider and the GB land automatically.",
  "Buy for": "Buy for {{price}}",
  "Pick a pack": "Pick a pack",
  "Confirm purchase": "Confirm the purchase",
  "Charge from balance": "Charge {{amount}} from your balance?",
  "Pay plan from balance": "Pay for “{{plan}}” from your balance? {{amount}} will be charged.",
  "Renew balance confirm": "Renew “{{plan}}” for {{days}}? {{amount}} will be charged from your balance.",
  "Payment confirm title": "Confirm payment",
  "Buy for price": "Buy for {{price}}₽",
  "Plans hint": "Pick a length, then a plan. The longer the term, the cheaper the day.",
  "Plans bypass title": "Works where others are blocked",
  "Plans bypass desc": "Gets through allow-lists and mobile-internet throttling",
  "Plans step period": "1. Subscription length",
  "Plans step plan": "2. Plan",
  "Popular": "POPULAR",
  "Unlimited everywhere": "Unlimited on every location",
  "GB for bypass": "{{gb}} GB for restricted sites",
  "Per day": "~{{price}} ₽/day",
  "Period short day": "d",
  "Period short month": "mo",
  "Period short months2": "2 mo",
  "Period short months3": "3 mo",
  "Period short months6": "6 mo",
  "Period short year": "yr",
  "Trial activated": "Your trial is on!",
  "Trial already used": "You've already used your trial.",
  "Trial unavailable": "The trial isn't available right now.",
  "Trial plan unavailable": "The trial plan is temporarily unavailable.",
  "Trial channels title": "Free trial for channel subscribers",
  "Trial channels note": "Join the channel, then start the free trial.",
  "Trial channel required": "Join the channel first, then start the free trial.",
  "Stars shop title": "No Stars yet?",
  "Stars shop step buy": "Stars needed: {{count}}. Buy them for rubles in our shop.",
  "Stars shop step pay": "Come back to the payment bot and tap «Pay».",
  "Buy stars": "Buy Stars",
  "Trial failed": "Couldn't start the trial. Please try again later.",
  "Try free": "Try it free",
  "Try free days": "Try it free for {{days}}",
  "Trial note": "A free trial, no payment. You can move to a paid plan afterwards.",
  "Trial bypass note": "The trial has no servers for restricted sites or throttled mobile internet: those work on paid plans only.",
  "Whitelist test done": "Restricted-sites test used",
  "Whitelist test buy": "Restricted-sites test for {{price}} ₽",
  "Whitelist used note": "This plan is a one-time purchase. After it, take a regular plan: there the bypass servers have no time limit.",
  "Plans locations note": "{{count}} included in every plan",
  "More": "details",
  "Voucher activated": "Subscription «{{plan}}» is active",
  "Voucher free": "The «{{plan}}» plan is free for you.",
  "Voucher title": "Gift code",
  "Activate": "Activate",
  "Promo exhausted": "The promo ran out: the invoice has no discount.",
  "Promo unavailable": "The promo code can't be applied right now, so the price is full. Contact the bot support.",
  "Get for free": "GET FOR FREE",
  "Free price": "Free",
  "Get for free confirm": "Get the subscription for free?",
  "Provider unavailable": "We couldn't issue the subscription yet. Your balance is intact, please try again in a few minutes",
  "Balance pay failed": "Couldn't pay from your balance",
  "Pay from balance": "Pay from balance · {{price}}\u00a0₽",
  "Biometry ask": "Confirm purchases with a fingerprint or Face ID? You can change this in your profile.",
  "Biometry title": "Purchase confirmation",
  "Yes": "Yes",
  "Pay amount": "Pay {{amount}}\u00a0₽?",
  "Plan gone": "Plan unavailable",
  "Plan gone desc": "Looks like this plan was withdrawn. The current ones are in the list.",
  "To plans": "To the plans",
  "From balance": "From balance",
  "Not enough topup": "{{amount}} ₽ short, top up",
  "Not enough": "{{amount}} ₽ short",
  "Top up arrow": "Top up →",
  "Whitelist scarce note": "Servers for restricted sites are scarce: they get blocked more and more often. So that everyone gets a shot, the test is cheap, lasts a couple of days and is a one-time purchase. If it works for you, take a regular plan.",
  "Whitelist test sub": "{{days}} · {{devices}}",
  "Whitelist test sub gb": "{{days}} · {{devices}} · {{gb}} GB for restricted sites",
  "Gift status pending": "Awaiting payment",
  "Gift status ready": "Ready to send",
  "Gift status claimed": "Redeemed",
  "Gift status expired": "Expired",
  "Gift title": "Gift a subscription",
  "Gift desc": "Pay for a plan and send your friend the link. They open it and get the subscription. You don't need one yourself.",
  "Gift create failed": "Couldn't create the gift: {{error}}",
  "Gift paid": "Gift paid from your balance, the link is ready",
  "Gift confirm buy": "Confirm the gift purchase",
  "Pick a plan": "Pick a plan",
  "Pay from balance section": "Pay from balance",
  "Gift from balance": "Gift from balance · {{price}} ₽",
  "Create invoice": "Create an invoice",
  "Gift paid note": "The gift is paid. Send the link to the person you're gifting.",
  "Gift invoice note": "The invoice is open. Once it's paid the link starts working: send it to your friend.",
  "Gifts empty": "No gifts yet",
  "Gifts empty desc": "Gifts you buy will show up here with their links.",
  "My gifts": "My gifts",
  "Gift created at": "Created {{date}}",
  "Gift paid at": "paid {{date}}",
  "Gift claimed by": "Redeemed by {{who}} · {{date}}",
  "Gift recipient": "the recipient",
  "Gift link copied": "Gift link copied",
  "Copy failed": "Couldn't copy",
  "Gift share text": "Here's a VPN subscription for you",
  "Share in Telegram": "Share in Telegram",
  "Payment check failed": "Couldn't verify the payment",
  "Payment check failed desc": "The backend is unreachable. If you've already paid, the money will arrive and the subscription turns on by itself.",
  "To home": "Home",
  "Payment pending": "The payment hasn't cleared yet",
  "Payment pending desc": "If you've already paid, the money arrives within a few minutes and the subscription turns on by itself. You can close this window.",
  "Paid sub coming": "Payment went through, the subscription is on its way",
  "Paid sub coming desc": "The money is on your balance and it stays there. We couldn't issue the subscription right away and are retrying automatically, which usually takes a few minutes. No need to pay again, we'll notify you.",
  "Check again now": "Check again",
  "Payment failed": "The payment didn't go through",
  "Invoice expired": "The invoice expired. Please try again.",
  "Invoice cancelled": "The invoice was cancelled. Please try again.",
  "Step crediting balance": "Crediting your balance",
  "Step crediting traffic": "Adding the traffic",
  "Step renewing": "Renewing the subscription",
  "Step preparing gift": "Preparing the gift",
  "Renew invoice failed": "Couldn't create the renewal invoice",
  "Renewed from balance": "Renewed from your balance",
  "Renew balance failed": "Couldn't renew from your balance",
  "Go paid caps": "CHOOSE A PLAN",
  "Pay from balance caps": "PAY {{price}} ₽ FROM BALANCE",
  "Renew unavailable": "Renewal isn't available",
  "Renew whitelist note": "It's a one-time purchase and can't be renewed: bypass servers are scarce. Take a regular plan, where they have no time limit.",
  "Renew whitelist name": "restricted-sites test",
  "Renew trial note": "it can't be renewed. To keep using the VPN, pick a paid plan.",
  "Renew trial name": "trial",
  "This is": "This is a",
  "Go to paid plan": "Choose a plan",
  "Renew frozen note": "The subscription is frozen. Unfreeze it on the home screen first, then you can renew.",
  "Renew period": "Renewal period",
  "Custom period": "Custom",
  "Plan period days_one": "{{count}} day (plan)",
  "Plan period days_few": "{{count}} days (plan)",
  "Plan period days_many": "{{count}} days (plan)",
  "Plan period days_other": "{{count}} days (plan)",
  "N days short_one": "{{count}} day",
  "N days short_few": "{{count}} days",
  "N days short_many": "{{count}} days",
  "N days short_other": "{{count}} days",
  "For N days_one": "for {{count}} day",
  "For N days_few": "for {{count}} days",
  "For N days_many": "for {{count}} days",
  "For N days_other": "for {{count}} days",
  "Days range hint": "from {{min}} to {{max}} days",
  "Renew promo applied": "Promo code {{code}} applied",
  "Active until date": "Active until {{date}}",
  "Auto renew period": "Renew for",
  "Auto renew period plan": "plan period",
  "Auto renew period custom": "{{count}} d.",
  "Renew title": "Renew subscription",
  "Renew adds to end": "The new term is added to your current end date.",
  "Opening client": "Opening {{client}}. If it isn't installed, copy the link below and import it manually.",
  "Link rotated": "Link refreshed. The old one no longer works.",
  "Rotate once per hour": "You can refresh the link once an hour. Please try again later.",
  "Rotate failed generic": "Couldn't refresh the link. Please try again later.",
  "Open connect page": "Open the connection page",
  "Rotate note long": "The old link stops working and nobody can connect with it any more. You'll have to add the profile again on your devices. Anyone already connected with the old link stays until this subscription ends.",
  "Just now": "just now",
  "Min ago": "{{count}} min ago",
  "Hours ago": "{{count}} h ago",
  "Yesterday": "yesterday",
  "Device disconnected": "Device disconnected. You can bring it back below",
  "Delete failed": "Couldn't remove it",
  "Device reconnecting": "The device is connecting again",
  "Device restore failed": "Couldn't bring the device back",
  "Online": "online",
  "Was online": "last seen {{when}}",
  "Activity unknown": "activity unknown",
  "Connected since": "connected {{when}}",
  "Disconnected devices": "Disconnected",
  "Disconnected desc": "We don't hand server settings to these devices. Restore one to let it connect again.",
  "Disconnected at": "disconnected {{when}}",
  "Restore": "Restore",
  "Disconnect device?": "Disconnect this device?",
  "Disconnect device desc": "{{name}} frees up a slot and stops receiving server settings: the app will show «Device disconnected». You can restore it right here, under «Disconnected».",
  "Disconnect": "Disconnect",
  "Loyalty": "Loyalty",
  "No status": "No status",
  "Renewals count": "Renewals: {{count}}",
  "Loyalty next": "{{count}} to go until «{{title}}» ({{bonus}}% bonus)",
  "Loyalty level bonus": "+{{bonus}}% on renewal",
  "Loyalty level renewals_one": "{{count}} renewal",
  "Loyalty level renewals_few": "{{count}} renewals",
  "Loyalty level renewals_many": "{{count}} renewals",
  "Loyalty level renewals_other": "{{count}} renewals",
  "Loyalty level left": "{{count}} to go",
  "Links": "Links",
  "Top up balance": "Top up balance",
  "Setting save failed": "Couldn't save the setting",
  "Biometry row": "Confirm with a fingerprint",
  "Biometry row desc": "Face ID or fingerprint before paying",
  "Backend down": "The server is unreachable, try again later",
  "Backend down desc": "Data isn't loading right now. We'll retry automatically.",
  "Report it": "Report",
  "Subscribe to continue": "Subscribe to continue",
  "Subscribe channels one": "To use the bot, subscribe to the channel below.",
  "Subscribe channels many": "To use the bot, subscribe to the channels below.",
  "Channel": "Channel",
  "I subscribed": "I've subscribed",
  "GB pack": "+{{gb}} GB",
  "GB pack unlimited": "+∞",
  "Plan word": "subscription",
  "No devices yet": "No devices yet",
  "Renew via": "RENEW FOR {{price}} ₽ VIA {{provider}}",
  "Fee badge": "fee {{percent}}%",
  "Expired title": "Your subscription has ended",
  "Expired on": "Expired {{date}}",
  "Expired renew hint": "Renew it and the VPN works again with the same link: no need to set up your devices again.",
  "Expired gone hint": "This plan is no longer sold. Pick a new one and your subscription starts right away.",
  "Expired section": "Ended",
  "Topup": "Top up by {{amount}} ₽",
  "Buy another plan": "Buy another plan",
  "Buy another plan hint": "A separate subscription with its own term and link",
  "Plans existing sub note": "You already have a subscription. A new purchase creates a separate one and does not extend the current one.",
  "Plans renew current": "Renew current",
  "Web access": "Web access",
  "Sign in on the website with your email, even if Telegram is unavailable": "Sign in on the website with your email, even if Telegram is unavailable",
  "Not set up": "Not set up",
  "Email": "Email",
  "Password": "Password",
  "At least 8 characters": "At least 8 characters",
  "At least 8 characters. If this email already has a website account, enter its password": "At least 8 characters. If this email already has a website account, enter its password",
  "Wrong password for the website account with this email": "Wrong password for the website account with this email",
  "Send code": "Send code",
  "Code from the email": "Code from the email",
  "We sent a code to {{email}}": "We sent a code to {{email}}",
  "Email linked, you can sign in on the website": "Email linked, you can sign in on the website",
  "Accounts merged, subscriptions from the website are here now": "Accounts merged, subscriptions from the website are here now",
  "This email already has a website account. After confirming, its subscriptions and balance will move here": "This email already has a website account. After confirming, its subscriptions and balance will move here",
  "Could not link email": "Could not link email",
  "Section term": "Term",
  "Section lifetime": "Lifetime",
  "Lifetime hint": "Pay once and the subscription never expires.",
  "Lifetime title": "Lifetime subscription",
  "Lifetime once note": "One payment, no renewals",
  "Lifetime no expiry": "Never expires",
  "Lifetime devices_one": "Up to {{count}} device",
  "Lifetime devices_few": "Up to {{count}} devices",
  "Lifetime devices_many": "Up to {{count}} devices",
  "Lifetime devices_other": "Up to {{count}} devices",
  "Lifetime own network": "Its own server network, separate from term subscriptions",
  "Lifetime servers unlimited": "Stable servers with no traffic limit",
  "Lifetime bypass traffic": "Fresh whitelist bypasses: {{gb}} GB, never expires",
  "Lifetime addons note": "Need more traffic or devices? Add them in the subscription card",
  "Lifetime get": "Get it",
  "Lifetime load failed": "Could not load the Lifetime plan.",
  "Lifetime unavailable": "The Lifetime section is not available right now.",
  "Show term plans": "Show term plans",
  "Trial choose note": "There is one trial per person. Pick the one you are going to keep using.",
  "Trial term option": "Term · {{days}}",
  "Trial term option note": "A regular subscription, then a plan for a month, half a year or a year.",
  "Trial lifetime option": "Lifetime · {{days}}",
  "Trial lifetime option note": "An exclusive plan that never expires. Its own server network, separate from term subscriptions: stable servers and fresh whitelist bypasses. The trial includes 10 GB on regular servers and 100 MB of bypass.",
  "Order plan lifetime": "Up to {{devices}} devices, lifetime",
  "Lifetime forever": "lifetime",
  "Term": "Term",
  "Traffic note lifetime": "Bypass traffic never expires. Other servers have no traffic limit.",
  "Choose plan": "Choose a plan",
  "Add devices": "+15 devices",
  "Add devices title": "15 more devices",
  "Add devices desc": "You can connect up to {{now}} devices now. After the purchase it will be {{after}}.",
  "Lifetime traffic desc": "The pack is added to your whitelist bypass balance and never expires until you use it. Other servers have no traffic limit anyway.",
  "Addons unavailable": "Add-ons are not available for this subscription right now.",
  "Addons load failed": "Could not load prices.",
  "Addon devices pack_one": "+{{count}} device",
  "Addon devices pack_few": "+{{count}} devices",
  "Addon devices pack_many": "+{{count}} devices",
  "Addon devices pack_other": "+{{count}} devices",
  "Addon done traffic": "Done: +{{gb}} GB of whitelist bypass traffic",
  "Addon done devices_one": "Done: up to {{count}} device now",
  "Addon done devices_few": "Done: up to {{count}} devices now",
  "Addon done devices_many": "Done: up to {{count}} devices now",
  "Addon done devices_other": "Done: up to {{count}} devices now",
  "Addon no balance": "Not enough money on your balance. Pay with an invoice or top up.",
  "Pay from balance price": "From balance · {{price}}",
  "Lifetime no renew": "The Lifetime subscription never expires, no renewal needed.",
  "Back to subscription": "Back to subscription",
  "Addon applied": "Done, the add-on is applied",
  "Step applying addon": "Adding to your subscription",
  "Withdraw title": "Withdraw earnings",
  "Withdraw manual note": "The service owner sends the money. We will message you in the chat once it is sent.",
  "Withdraw load failed": "Could not load withdrawal details.",
  "Withdraw unavailable title": "Withdrawals are unavailable",
  "Withdraw unavailable desc": "The service owner has turned withdrawals off. Bonuses still go to your balance, and you can pay for a subscription with them.",
  "Withdraw history": "Request history",
  "Withdraw earned": "Earned from referrals",
  "Withdraw available": "Available to withdraw",
  "Withdraw available short": "{{amount}} available",
  "Withdraw available note": "This excludes what you have already withdrawn or what is held in a request. Payments from your balance use referral earnings first.",
  "Withdraw request label": "Withdrawal request",
  "Withdraw waiting transfer": "Waiting for the service owner to send the money. While the request is open, the amount is held from your balance.",
  "Withdraw processing note": "The service owner is sending the money right now. The request can no longer be cancelled.",
  "Withdraw where": "Where to",
  "Withdraw details": "Details",
  "Withdraw created": "Created",
  "Withdraw cancel": "Cancel request",
  "Withdraw cancelling": "Cancelling…",
  "Withdraw cancel title": "Cancel the request?",
  "Withdraw cancel desc": "{{amount}} will go back to your balance. You can send a new request right away.",
  "Withdraw keep": "Keep it",
  "Withdraw cancelled toast": "Request cancelled, {{amount}} is back on your balance",
  "Withdraw already decided": "This request has already been decided, the status is updated.",
  "Withdraw cancel failed": "Could not cancel the request. Please try again.",
  "Withdraw processing no cancel": "The service owner is already sending the money, so the request can't be cancelled.",
  "Withdraw amount whole": "Enter the amount as a whole number.",
  "Withdraw amount min": "The minimum withdrawal is {{amount}}.",
  "Withdraw amount max": "You can withdraw up to {{amount}}.",
  "Withdraw min hint": "Minimum {{amount}}",
  "Withdraw all chip": "All: {{amount}}",
  "Withdraw not enough": "{{amount}} more to withdraw",
  "Withdraw not enough hint": "Withdrawals start at {{amount}}. You get a bonus when an invited friend pays for a subscription.",
  "Withdraw from min": "Withdrawals from {{amount}}",
  "Withdraw no methods": "The service owner hasn't set up payout methods yet. Please check back later.",
  "Withdraw method card": "Card",
  "Withdraw method sbp": "SBP",
  "Withdraw method usdt_trc20": "USDT TRC20",
  "Withdraw method gone": "This method is no longer available. Choose another one.",
  "Withdraw card label": "Card number",
  "Withdraw card hint": "16 to 19 digits, as on the card.",
  "Withdraw card short": "A card number has 16 to 19 digits.",
  "Withdraw card invalid": "This card number doesn't pass the check. Compare the digits with your card.",
  "Withdraw phone label": "Phone",
  "Withdraw phone hint": "The number you receive SBP transfers on.",
  "Withdraw phone invalid": "Enter a Russian number: +7 and 10 digits.",
  "Withdraw bank label": "Bank",
  "Withdraw bank hint": "The bank where you receive SBP transfers.",
  "Withdraw bank placeholder": "For example, T-Bank",
  "Withdraw bank invalid": "Bank name: 2 to {{max}} characters.",
  "Withdraw trc20 label": "USDT address (TRC20)",
  "Withdraw trc20 hint": "TRON network, the address starts with T. A transfer on another network won't arrive.",
  "Withdraw trc20 invalid": "A TRC20 address starts with T and has 34 characters.",
  "Withdraw submit": "Withdraw",
  "Withdraw submit amount": "Withdraw {{amount}}",
  "Withdraw confirm title": "Check your request",
  "Withdraw confirm message": "Amount: {{amount}}\n{{method}}: {{destination}}\n\nThe service owner will send the money to these details. Is everything correct?",
  "Withdraw confirm ok": "Send",
  "Withdraw sent toast": "Request for {{amount}} sent. We'll message you in the chat when the money is on its way.",
  "Withdraw paid now toast": "Done: {{amount}} has been sent. The check and details are in the chat and in the history below.",
  "Withdraw open exists": "You already have an open request. Wait for a response or cancel it.",
  "Withdraw send failed": "Could not send the request. Please try again a little later.",
  "Withdraw too frequent": "Too many requests in the last hour. Please try again later.",
  "Withdraw open short": "Request for {{amount}} awaits transfer",
  "Withdraw processing short": "Request for {{amount}}: the money is on its way",
  "Withdraw status pending": "Pending",
  "Withdraw status processing": "Sending",
  "Withdraw status paid": "Paid",
  "Withdraw status rejected": "Rejected",
  "Withdraw status cancelled": "Cancelled",
  "Withdraw reject reason": "Reason: {{reason}}",
  "Withdraw method ton": "GRAM (TON)",
  "Withdraw method cryptobot": "CryptoBot (USDT)",
  "Withdraw to telegram": "your Telegram",
  "Withdraw platform note": "The service pays this out automatically. We will message you in the chat once the money is sent.",
  "Withdraw ton label": "TON wallet address",
  "Withdraw ton hint": "A wallet on the TON network to receive GRAM. The address starts with UQ or EQ.",
  "Withdraw ton invalid": "This does not look like a TON wallet address: it starts with UQ or EQ and has 48 characters.",
  "Withdraw memo label": "Comment (memo)",
  "Withdraw memo hint": "Required if the wallet is on an exchange, otherwise the exchange will not credit the transfer. Leave empty for a regular wallet.",
  "Withdraw memo placeholder": "Optional",
  "Withdraw memo invalid": "Comment: up to {{max}} characters, on one line.",
  "Withdraw cryptobot note": "A @CryptoBot check in USDT will arrive in this chat. Only you can claim it, from your own Telegram.",
  "Withdraw net label": "You receive",
  "Withdraw net line": "With an automatic payout you receive {{net}}",
  "Withdraw fee line": "The network and service fee of {{fee}} is taken from the amount.",
  "Withdraw quote failed": "Could not calculate the fee. Please try again a bit later.",
  "Withdraw confirm net": "With an automatic payout you receive {{net}}.",
  "Withdraw open check": "Claim the check",
  "Withdraw open tx": "Transfer on TON",
  "Intent withdraw request": "Withdrawal request",
  "Intent withdraw return": "Withdrawal returned to balance",
  "Intent account merge": "Balance moved when accounts were merged",
  "Intent account merge bonus": "Bonuses moved when accounts were merged",
  "FAQ questions": "Questions and answers",
  "Countries in subscription": "Countries in subscription",
  "Countries shown of": "{{shown}} of {{total}}",
  "Countries explain": "Pick the countries you want in your VPN app. New countries appear automatically.",
  "Countries locked": "The service owner turned off country selection.",
  "Countries show all": "Show all countries",
  "Countries servers_one": "{{count}} server",
  "Countries servers_few": "{{count}} servers",
  "Countries servers_many": "{{count}} servers",
  "Countries servers_other": "{{count}} servers",
  "Countries limited": "whitelist bypass: {{count}}",
  "Countries saved": "Saved",
  "Countries saved hint": "Refresh the subscription in your VPN app to update the list.",
  "Countries save failed": "Could not save, please try again.",
  "Countries load failed": "Could not load the countries.",
  "Countries keep one": "Keep at least one country.",
  "All countries shown": "All countries",
  "Save": "Save",
  "Saving": "Saving…",
  "Countries auto note": "«🌍 Auto-select» in Happ picks a server from all countries. To use only the chosen ones, pick a server in the app manually."
};

export default en;
